/* eslint-disable  */

/**
 * External Dependencies
 */
import $ from 'jquery';
import _ from 'lodash';

/**
 * Internal Dependencies
 */
import URLMANAGER from './url';

$.ajaxSetup({
	beforeSend: function(xhr, options) {
		xhr.setRequestHeader("Content-Type", 'application/x-www-form-urlencoded');
	},
	xhrFields: {
		withCredentials: true
	},
		crossDomain: true,
	
});

const API = {
	url: `/api`,
	/**
	 * Update or Create the Hypothes.is annotation
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	updateOrCreateAnnotation: function(opts = {}, done) {
		return $.ajax({
			type: `PUT`,
			data: _.get(opts, `data`, {}),
			url: URLMANAGER.buildURL(`${this.url}/hypothesis/bioRxiv`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`updateOrCreateAnnotation`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Get the Crisp id
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	getCrispId: function(done) {
		return $.ajax({
			type: `GET`,
			url: URLMANAGER.buildURL(`${this.url}/getCrispId`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`getCrispId`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Get the userflow token
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	getUserflowToken: function(done) {
		return $.ajax({
			type: `GET`,
			url: URLMANAGER.buildURL(`${this.url}/getUserflowToken`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`getUserflowToken`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Signin a given user
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	signin: function(opts = {}, done) {
		return $.ajax({
			type: `POST`,
			url: URLMANAGER.buildURL(`${this.url}/signin`, {}, { origin: true }),
			data: _.get(opts, `data`, {}),
			success: function(query) {
				console.log(`signin`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Signup a given user
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	signup: function(opts = {}, done) {
		return $.ajax({
			type: `POST`,
			url: URLMANAGER.buildURL(`${this.url}/signup`, {}, { setToken: true, origin: true }),
			data: _.get(opts, `data`, {}),
			success: function(query) {
				console.log(`signup`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Process "forget password" for a given user
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	forgotPassword: function(opts = {}, done) {
		return $.ajax({
			type: `POST`,
			url: URLMANAGER.buildURL(`${this.url}/forgotPassword`, {}, { setToken: true, origin: true }),
			data: _.get(opts, `data`, {}),
			success: function(query) {
				console.log(`forgotPassword`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Reset password of a given user
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	resetPassword: function(opts = {}, done) {
		return $.ajax({
			type: `POST`,
			url: URLMANAGER.buildURL(`${this.url}/resetPassword`, {}, { setToken: true, origin: true }),
			data: _.get(opts, `data`, {}),
			success: function(query) {
				console.log(`resetPassword`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Get the current user
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	currentUser: function(opts = {}, done) {
		return $.ajax({
			type: `GET`,
			url: URLMANAGER.buildURL(`${this.url}/currentUser`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`currentUser`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Get logs of "model"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	getLogs: function(model, opts = {}, done) {
		return $.ajax({
			type: `GET`,
			url: URLMANAGER.buildURL(
				`${this.url}/${model}/${opts.id}/logs`,
				_.get(opts, `params`, {}),
				{
					setToken: true,
					origin: true
				}
			),
			success: function(query) {
				console.log(`getLogs`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Get a given "model"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	get: function(model, opts = {}, done) {
		return $.ajax({
			type: `GET`,
			url: URLMANAGER.buildURL(`${this.url}/${model}/${opts.id}`, _.get(opts, `params`, {}), {
				setToken: true,
				origin: true
			}),
			success: function(query) {
				console.log(`get`, model, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Get all "things"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	all: function(model, opts = {}, done) {
		return $.ajax({
			type: `GET`,
			url: URLMANAGER.buildURL(`${this.url}/${model}`, opts.params, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`all`, model, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Add a given "model"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	add: function(model, opts = {}, done) {
		return $.ajax({
			type: `POST`,
			data: _.get(opts, `data`, {}),
			url: URLMANAGER.buildURL(`${this.url}/${model}`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`add`, model, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Update a given "model"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	update: function(model, opts = {}, done) {
		return $.ajax({
			type: `PUT`,
			data: _.get(opts, `data`, {}),
			url: URLMANAGER.buildURL(
				`${this.url}/${model}/${opts.data._id}`,
				{},
				{ setToken: true, origin: true }
			),
			success: function(query) {
				console.log(`update`, model, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Update many "things"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	updateMany: function(model, opts = {}, done) {
		return $.ajax({
			type: `PUT`,
			data: _.get(opts, `data`, {}),
			url: URLMANAGER.buildURL(`${this.url}/${model}`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`updateMany`, model, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Delete a given "model"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	delete: function(model, opts = {}, done) {
		return $.ajax({
			type: `DELETE`,
			data: _.get(opts, `data`, {}),
			url: URLMANAGER.buildURL(
				`${this.url}/${model}/${opts.data._id}`,
				{},
				{ setToken: true, origin: true }
			),
			success: function(query) {
				console.log(`delete`, model, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Delete many "things"
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	deleteMany: function(model, opts = {}, done) {
		return $.ajax({
			type: `DELETE`,
			data: _.get(opts, `data`, {}),
			url: URLMANAGER.buildURL(`${this.url}/${model}`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`deleteMany`, model, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	/**
	 * Upload some files
	 * @param {string} model Which model of data will be used (accounts, organizations, documents, etc)
	 * @param {object} opts JSON object containing all data
	 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
	 * @returns {undefined} undefined
	 */
	upload: function(model, opts = {}, done) {
		return $.ajax({
			type: `POST`,
			data: _.get(opts, `data`, {}),
			processData: false,
			contentType: false,
			enctype: `multipart/form-data`,
			url: URLMANAGER.buildURL(`${this.url}/${model}`, {}, { setToken: true, origin: true }),
			success: function(query) {
				console.log(`upload`, query);
				return done(false, query);
			},
			error: function(query) {
				return done(query);
			}
		});
	},
	dataseerML: {
		url: `api/dataseer-ml`,
		/**
		 * Resync jsonDataTypes
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		resyncJsonDataTypes: function(done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(`${this.url}/resyncJsonDataTypes`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`dataseerML.resyncJsonDataTypes`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
		/**
		 * Get jsonDataTypes
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		jsonDataTypes: function(done) {
			return $.ajax({
				type: `GET`,
				url: URLMANAGER.buildURL(`${this.url}/jsonDataTypes`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`dataseerML.jsonDataTypes`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Extract DataTypes from data (result of DataSeerAPI.jsonDataTypes())
		 * @param {object} data JSON object containing all data
		 * @returns {object} JSON object containing all DataTypes
		 */
		extractDatatypeFrom: function(data) {
			let classifications =
				data[`classifications`].length > 0 &&
				typeof data[`classifications`][0] === `object` &&
				data[`classifications`][0].has_dataset > data[`classifications`][0].no_dataset
					? data[`classifications`][0]
					: {};
			let result = {};
			delete classifications.text;
			delete classifications.has_dataset;
			delete classifications.no_dataset;
			let keys = Object.keys(classifications);
			if (keys.length > 0) {
				let datatype = keys[0];
				let max = typeof classifications[keys[0]] === `number` ? classifications[keys[0]] : 0;
				for (let i = 1; i < keys.length; i++) {
					if (typeof classifications[keys[i]] !== `number`) continue;
					if (max < classifications[keys[i]]) {
						max = classifications[keys[i]];
						datatype = keys[i];
					}
				}
				// result.datatype = datatype;
				result.datatype = datatype.toLowerCase(); // lowercase to match with metadata returned by dataseer-ml
				result.cert = max;
				result.reuse = classifications.reuse;
			}
			return result;
		},
		/**
		 * Get datatype of given sentence
		 * @param {object} sentence Sentence HTML element
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		getdataType: function(sentence, done) {
			return $.ajax({
				cache: false,
				type: `POST`,
				data: sentence,
				url: URLMANAGER.buildURL(
					`${this.url}/processDataseerSentence`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`dataseerML.getdataType`, query);
					let result = API.dataseerML.extractDatatypeFrom(query);
					return done(null, result);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		}
	},
	scicrunch: {
		url: `api/scicrunch`,
		/**
		 * Call searchEntity on given entity
		 * @param {object} opts opts
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		searchEntity: function (opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: opts,
				url: URLMANAGER.buildURL(`${this.url}/searchEntity`, {}, { setToken: true, origin: true }),
				success: function (query) {
					console.log(`scicrunch.searchEntity`, query);
					return done(false, query);
				},
				error: function (query) {
					return done(query);
				}
			});
		},
		/**
		 * Call processEntity on given entity
		 * @param {object} opts opts
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		processEntity: function (opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: opts,
				url: URLMANAGER.buildURL(`${this.url}/processEntity`, {}, { setToken: true, origin: true }),
				success: function (query) {
					console.log(`scicrunch.processEntity`, query);
					return done(false, query);
				},
				error: function (query) {
					return done(query);
				}
			});
		},
		/**
		 * Call processRRID on given RRID
		 * @param {object} opts opts
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		processRRID: function (opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: opts,
				url: URLMANAGER.buildURL(`${this.url}/processRRID`, {}, { setToken: true, origin: true }),
				success: function (query) {
					console.log(`scicrunch.processRRID`, query);
					return done(false, query);
				},
				error: function (query) {
					return done(query);
				}
			});
		}
	},
	repoRecommender: {
		url: `api/repoRecommender`,
		/**
		 * Call findRepo on given dataset
		 * @param {object} opts opts
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		findRepo: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: opts,
				url: URLMANAGER.buildURL(`${this.url}/findRepo`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`repoRecommender.findRepo`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		}
	},
	dataObjects: {
		url: `api/documents`,
		/**
		 * Create new dataObjects
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.documentId Id of document
		 * @param {array} opts.dataObjects DataObject options
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		create: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.documentId}/dataObjects`,
					{},
					{ setToken: true, origin: true }
				),
				data: { dataObjects: opts.dataObjects },
				success: function(query) {
					console.log(`dataObjects.create`, query);
					return done(false, query);
				},
				error: function() {
					return done(true);
				}
			});
		},
		/**
		 * pdate existing dataObjects
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.documentId Id of document
		 * @param {array} opts.dataObjects DataObject options
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		update: function(opts = {}, done) {
			return $.ajax({
				type: `PUT`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.documentId}/dataObjects`,
					{},
					{ setToken: true, origin: true }
				),
				data: { dataObjects: opts.dataObjects },
				success: function(query) {
					console.log(`dataObjects.update`, query);
					return done(false, query);
				},
				error: function(jqXHR) {
					// The status has to survive: 409 means the data object was
					// changed by someone else and the write was refused, which
					// the caller must tell apart from a server fault - one is
					// worth retrying, the other can only fail again.
					return done({ status: jqXHR ? jqXHR.status : 0 });
				}
			});
		},
		/**
		 * Delete dataObjects
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.documentId Id of document
		 * @param {array} opts.dataObjects DataObject options
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		delete: function(opts = {}, done) {
			return $.ajax({
				type: `DELETE`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.documentId}/dataObjects`,
					{},
					{ setToken: true, origin: true }
				),
				data: { dataObjects: opts.dataObjects },
				success: function(query) {
					console.log(`dataObjects.delete`, query);
					return done(false, query);
				},
				error: function() {
					return done(true);
				}
			});
		},
		/**
		 * Get Logs of a given DataObject
		 * @param {object} opts JSON object containing all data
		 * @param {object} opts.dataObject DataObject options
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		getLogs: function(opts = {}, done) {
			return $.ajax({
				type: `GET`,
				url: URLMANAGER.buildURL(
					`api/dataObjects/${opts.dataObject._id}/logs`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`dataObjects.getLogs`, query);
					return done(false, query);
				},
				error: function() {
					return done(true);
				}
			});
		},
	},
	datasets: {
		url: `api/datasets`,
		/**
		 * Create new dataset to datasets
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.datasetsId Id of document datasets
		 * @param {object} opts.sentence Sentence options
		 * @param {string} opts.sentence.id Sentence id
		 * @param {string} opts.sentence.text Sentence text
		 * @param {object} opts.dataset Dataset options
		 * @param {string} opts.dataset.status Dataset status
		 * @param {string} opts.dataset.id Dataset id
		 * @param {string} opts.dataset.datainstanceId Dataset datainstanceId
		 * @param {string} opts.dataset.cert Dataset cert
		 * @param {string} opts.dataset.dataType Dataset dataType
		 * @param {string} opts.dataset.subType Dataset subType
		 * @param {string} opts.dataset.description Dataset description
		 * @param {string} opts.dataset.bestDataFormatForSharing Dataset bestDataFormatForSharing
		 * @param {string} opts.dataset.mostSuitableRepositories Dataset mostSuitableRepositories
		 * @param {string} opts.dataset.name Dataset name
		 * @param {string} opts.dataset.DOI Dataset DOI
		 * @param {string} opts.dataset.comments Dataset comments
		 * @param {string} opts.dataset.status Dataset comments
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		createDataset: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.datasetsId}/dataset`,
					{},
					{ setToken: true, origin: true }
				),
				data: { dataset: opts.dataset, sentence: opts.sentence },
				success: function(query) {
					console.log(`datasets.createDataset`, query);
					return done(false, query);
				},
				error: function() {
					return done(true);
				}
			});
		},
		/**
		 * Save a given dataset
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.datasetsId Id of document datasets
		 * @param {object} opts.dataset Dataset options
		 * @param {string} opts.dataset.status Dataset status
		 * @param {string} opts.dataset.id Dataset id
		 * @param {string} opts.dataset.cert Dataset cert
		 * @param {string} opts.dataset.dataType Dataset dataType
		 * @param {string} opts.dataset.subType Dataset subType
		 * @param {string} opts.dataset.description Dataset description
		 * @param {string} opts.dataset.bestDataFormatForSharing Dataset bestDataFormatForSharing
		 * @param {string} opts.dataset.mostSuitableRepositories Dataset mostSuitableRepositories
		 * @param {string} opts.dataset.name Dataset name
		 * @param {string} opts.dataset.DOI Dataset DOI
		 * @param {string} opts.dataset.comments Dataset comments
		 * @param {string} opts.dataset.status Dataset comments
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		updateDataset: function(opts = {}, done) {
			return $.ajax({
				type: `PUT`,
				data: { dataset: opts.dataset },
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.datasetsId}/dataset`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`datasets.updateDataset`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Delete a given dataset
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.datasetsId Id of datasets
		 * @param {string} opts.dataset.id Id of dataset
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		deleteDataset: function(opts = {}, done) {
			return $.ajax({
				type: `DELETE`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.datasetsId}/dataset`,
					{},
					{ setToken: true, origin: true }
				),
				data: { dataset: opts.dataset },
				success: function(query) {
					console.log(`datasets.deleteDataset`, query);
					return done(false, query);
				},
				error: function() {
					return done(true);
				}
			});
		},
		/**
		 * Create new link to datasets
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.datasetsId Id of datasets
		 * @param {object} opts.link Link
		 * @param {object} opts.link.sentence Sentence
		 * @param {string} opts.link.sentence.id Sentence id
		 * @param {object} opts.link.dataset Dataset
		 * @param {string} opts.link.dataset.id Dataset id
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		linkSentence: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.datasetsId}/link`,
					{},
					{ setToken: true, origin: true }
				),
				data: { link: opts.link },
				success: function(query) {
					console.log(`datasets.linkSentence`, query);
					return done(false, query);
				},
				error: function() {
					return done(true);
				}
			});
		},
		/**
		 * Delete a given dataset link
		 * @param {object} opts JSON object containing all data
		 * @param {string} opts.datasetsId Id of datasets
		 * @param {object} opts.link Link
		 * @param {object} opts.link.sentence Sentence
		 * @param {string} opts.link.sentence.id Sentence id
		 * @param {object} opts.link.dataset Dataset
		 * @param {string} opts.link.dataset.id Dataset id
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		unlinkSentence: function(opts = {}, done) {
			return $.ajax({
				type: `DELETE`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.datasetsId}/unlink`,
					{},
					{ setToken: true, origin: true }
				),
				data: { link: opts.link },
				success: function(query) {
					console.log(`datasets.unlinkSentence`, query);
					return done(false, query);
				},
				error: function() {
					return done(true);
				}
			});
		}
	},
	documents: {
		url: `api/documents`,
		/**
		 * Check sentences content of a document by id
		 * @param {object} opts - Options available
		 * @param {string} opts.source - Id of the source document (that contain datasets you want to import)
		 * @param {string} opts.target - Id of the target document (that will receiving imported datasets)
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		importDatasets: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: { onlyLogs: opts.onlyLogs },
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.target}/importDatasets/${opts.source}`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.importDatasets`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Refresh DataObjects Suggested Properties
		 * @param {object} opts - Options available
		 * @param {string} opts.id - Document Id
		 * @param {object} opts.params - Params
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		refreshDataObjectsSuggestedProperties: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `params`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/dataObjects/refreshSuggestedProperties`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.dataObjects.refreshSuggestedProperties`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Check sentences content of a document by id
		 * @param {object} opts - Options available
		 * @param {array} opts.kind - Kind of template
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		getDataObjectsChangesSpreadsheets: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/dataObjects/changes/gSpreadsheets/${opts.kind}/${opts.config}`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.getDataObjectsChangesSpreadsheets`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Check sentences content of a document by id
		 * @param {object} opts - Options available
		 * @param {array} opts.kind - Kind of template
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		postRefreshASAPKRTRoster: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/ASAPKRTRoster/refresh`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.postRefreshASAPKRTRoster`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Check sentences content of a document by id
		 * @param {object} opts - Options available
		 * @param {array} opts.kind - Kind of template
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		postRefreshASAPKeywordsDocumentsList: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/ASAPKeywords/refresh`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.postRefreshASAPKeywordsDocumentsList`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Check sentences content of a document by id
		 * @param {object} opts - Options available
		 * @param {array} opts.documents - All documents ids
		 * @param {array} opts.trustedAccounts - All trusted accounts ids
		 * @param {array} opts.untrustedAccounts - All untrusted accounts ids
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		getDataObjectsChangesCSV: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {
					documents: opts.documents,
					trustedAccounts: opts.trustedAccounts,
					untrustedAccounts: opts.untrustedAccounts
				},
				url: URLMANAGER.buildURL(
					`${this.url}/dataObjects/changes/csv`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.getDataObjectsChangesCSV`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Check sentences content of a document by id
		 * @param {object} opts - Options available
		 * @param {array} opts.documents - All documents ids
		 * @param {array} opts.accounts - All accounts ids
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		getDataObjectsHistories: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {
					documents: opts.documents,
					accounts: opts.accounts
				},
				url: URLMANAGER.buildURL(
					`${this.url}/dataObjects/histories`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.getdataObjectsHistories`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Check sentences content of a document by id
		 * @param {object} opts - Options available
		 * @param {string} opts.source - Id of the source document (that contain datasets you want to import)
		 * @param {string} opts.target - Id of the target document (that will receiving imported datasets)
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		importDataObjects: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: { onlyLogs: opts.onlyLogs },
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.target}/importDataObjects/${opts.source}`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.importDataObjects`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Import data from Softcite
		 * @param {object} opts - Options available
		 * @param {string} opts.documentId - Id of the source document (that contain datasets you want to import)
		 * @param {boolean} opts.params.softcite - Request softcite if necessary (default: true)
		 * @param {boolean} opts.params.ignoreSoftCiteCommandLines - Ignore command lines (default: false)
		 * @param {boolean} opts.params.ignoreSoftCiteSoftware - Ignore software (default: false)
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		importDataFromSoftcite: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `params`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.documentId}/softcite/importData`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.importDataFromSoftcite`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Extract data from Softcite
		 * @param {object} opts - Options available
		 * @param {string} opts.documentId - Id of the source document (that contain datasets you want to import)
		 * @param {boolean} opts.params.softcite - Request softcite if necessary (default: true)
		 * @param {boolean} opts.params.ignoreSoftCiteCommandLines - Ignore command lines (default: false)
		 * @param {boolean} opts.params.ignoreSoftCiteSoftware - Ignore software (default: false)
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		extractDataFromSoftcite: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `params`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.documentId}/softcite/extractData`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.extractDataFromSoftcite`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Import data from BioNLP
		 * @param {object} opts - Options available
		 * @param {string} opts.documentId - Id of the source document (that contain datasets you want to import)
		 * @param {boolean} opts.params.bioNLP - Request bioNLP if necessary (default: true)
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		importDataFromBioNLP: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `params`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.documentId}/bioNLP/importData`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.importDataFromBioNLP`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Extract data from BioNLP
		 * @param {object} opts - Options available
		 * @param {string} opts.documentId - Id of the source document (that contain datasets you want to import)
		 * @param {boolean} opts.params.bioNLP - Request bioNLP if necessary (default: true)
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		extractDataFromBioNLP: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `params`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.documentId}/bioNLP/extractData`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.extractDataFromBioNLP`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Detect new sentences
		 * @param {object} opts - Options available
		 * @param {string} opts.id - Id of the document
		 * @param {object} opts.params - Available parameters
		 * @param {object} opts.params.pages - Range of pages
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		detectNewSentences: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `params`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/detectNewSentences`,
					{},
					{
						setToken: true,
						origin: true
					}
				),
				success: function(query) {
					console.log(`documents.importDatasets`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Process OCR
		 * @param {object} opts - Options available
		 * @param {string} opts.id - Id of the document
		 * @param {object} opts.params - Available parameters
		 * @param {object} opts.params.pages - Range of pages
		 * @param {function} cb - Callback function(err, res) (err: error process OR null, res: document instance OR undefined)
		 * @returns {undefined} undefined
		 */
		processOCR: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `params`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/processOCR`,
					{},
					{
						setToken: true,
						origin: true
					}
				),
				success: function(query) {
					console.log(`documents.processOCR`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Get PDF of given document
		 * @param {object} opts Options
		 * @param {string} documentId Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		getReport: function(opts = {}, done) {
			return $.ajax({
				type: `GET`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/reports/${opts.kind}/${opts.organization}`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.getReport`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Get PDF of given document
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		getPDF: function(opts = {}, done) {
			return $.ajax({
				type: `GET`,
				url: URLMANAGER.buildURL(`${this.url}/${opts.id}/pdf`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`documents.getPDF`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Get TEI of given document
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		getTEI: function(opts = {}, done) {
			return $.ajax({
				type: `GET`,
				url: URLMANAGER.buildURL(`${this.url}/${opts.id}/tei`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`documents.getTEI`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Get TEI content of given document
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		getTEIContent: function(opts = {}, done) {
			return $.ajax({
				type: `GET`,
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/tei/content`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.getTEIContent`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Refresh token of given document
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		refreshToken: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/refreshToken`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.refreshToken`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Reload "Metadata" of given document
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		reloadMetadata: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `data`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/metadata/reload`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.reloadMetadata`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Validate "Metadata" process of given document
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		validateMetadata: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/metadata/validate`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.validateMetadata`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Validate "Datasets" process of given document
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		validateDatasets: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/datasets/validate`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.validateDatasets`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Reopen document (back to "Metadata" process)
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		reopen: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/finish/reopen`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.reopen`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Back to "Metadata" process from "datasets" step
		 * @param {object} opts Options
		 * @param {string} opts.id Id of document
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		backToMetadata: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: {},
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/datasets/backToMetadata`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`documents.backToMetadata`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Build report (google spreadsheet)
		 * @param {object} opts JSON object containing all data
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		buildGSpreadSheetReport: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `data`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/${opts.id}/reports/gSpreadsheets/${opts.kind}`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`buildGSpreadSheetReport`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		},
		/**
		 * Build report (google spreadsheet)
		 * @param {object} opts JSON object containing all data
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		_buildGSpreadSheetReport: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: _.get(opts, `data`, {}),
				url: URLMANAGER.buildURL(
					`${this.url}/reports/gSpreadsheets/${opts.kind}`,
					{},
					{ setToken: true, origin: true }
				),
				success: function(query) {
					console.log(`_buildGSpreadSheetReport`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(query);
				}
			});
		}
	},
	ORCID: {
		url: `api/orcid`,
		/**
		 * Resync jsonDataTypes
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		refreshASAPAuthors: function(done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(`${this.url}/ASAP/refreshAuthors`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`ORCID.refreshASAPAuthors`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
		/**
		 * Resync jsonDataTypes
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		refreshBD2Authors: function(done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(`${this.url}/BD2/refreshAuthors`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`ORCID.refreshBD2Authors`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
	},
	software: {
		url: `api/software`,
		/**
		 * Resync custom software list
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		refreshCustomList: function(done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(`${this.url}/customList/refresh`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`software.refreshCustomList`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
		/**
		 * Search for a software in the custom software list
		 * @param {object} opts JSON object containing all data
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		find: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: opts,
				url: URLMANAGER.buildURL(`${this.url}/customList/find`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`software.find`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
	},
	reagents: {
		url: `api/reagents`,
		/**
		 * Resync custom reagents list
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		refreshCustomList: function(done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(`${this.url}/customList/refresh`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`reagents.refreshCustomList`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
		/**
		 * Search for a reagent in the custom reagents list
		 * @param {object} opts JSON object containing all data
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		find: function(opts = {}, done) {
			return $.ajax({
				type: `POST`,
				data: opts,
				url: URLMANAGER.buildURL(`${this.url}/customList/find`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`reagents.find`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
	},
	identifiers: {
		url: `api/identifiers`,
		/**
		 * Resync custom identifiers list
		 * @param {function} done Callback function(err, res) (err: error process OR null, res: infos/data OR undefined)
		 * @returns {undefined} undefined
		 */
		refreshCustomList: function(done) {
			return $.ajax({
				type: `POST`,
				url: URLMANAGER.buildURL(`${this.url}/customList/refresh`, {}, { setToken: true, origin: true }),
				success: function(query) {
					console.log(`identifiers.refreshCustomList`, query);
					return done(false, query);
				},
				error: function(query) {
					return done(true, query);
				}
			});
		},
	}
};

export default API;
